"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var EEOClassResource = /** @class */ (function (_super) {
    tslib_1.__extends(EEOClassResource, _super);
    function EEOClassResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EEOClassResource.endpoint = '/eeoclasses';
    EEOClassResource.MODEL_NAME = 'eeoclass';
    return EEOClassResource;
}(base_1.default));
exports.default = EEOClassResource;
//# sourceMappingURL=eeoclass.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/eeoclass.js
// module id = Yf3/
// module chunks = 0